import ModalContainer from './ModalContainer'

const ModalPlugin ={
  install (Vue, options) {

    if(this.installed) {
      return
    }

    this.installed = true
    this.container = null

    Vue.prototype.$modal = {

      setContainer (container) {
        Plugin.container = container
      },

      show(modal, props, events) {
        Plugin.container.show(modal, props, events)
      },

      loading(loading) {
        Plugin.container.setLoading(loading)
      },

      close() {
        Plugin.container.close()
      }

    }

    Vue.component('modal-container', ModalContainer)
  }
}

export default ModalPlugin